module.exports = __webpack_public_path__ + "static/media/benedict-cover.1d28e4b3.jpg";